import http from "../http-common";
import httpFile from "../http-common-file";

class TutorialDataService {
  getDatabases() {
    return http.get("/databases");
  }

  // Получить список коллекций в базе данных
  getCollections(dbName) {
    const params = dbName ? `?dbName=${dbName}` : "";
    return http.get(`/collections${params}`);
  }

  // Копировать базу данных
  copyDatabase(data) {
    return http.post("/copy-database", data);
  }

  // Восстановить базу данных из копии
  restoreDatabase(data) {
    return http.post("/restore-database", data);
  }

  // Получить информацию о базе данных (статистика)
  getDatabaseInfo(dbName) {
    return http.get(`/database-info?dbName=${dbName}`);
  }

  // Удалить базу данных (осторожно!)
  deleteDatabase(dbName) {
    return http.delete(`/database/${dbName}`);
  }

  // Создать новую пустую базу данных
  createDatabase(dbName) {
    return http.post("/create-database", { dbName });
  }

  // Экспортировать коллекцию в JSON
  exportCollection(data) {
    return http.post("/export-collection", data);
  }

  // Импортировать коллекцию из JSON
  importCollection(data) {
    return http.post("/import-collection", data);
  }

  //reciept
  getDateWorld() {
    return http.get("/getDateWorld");
  }
  createReciept(data) {
    return http.post("/createReciept", data);
  }
  PayReciept(data) {
    return http.post("/PayReciept", data);
  }

  findReciept(classID) {
    return http.post(`/findReciept/id=`, classID);
  }

  findRecieptByDateRange(data) {
    return http.post(`/findRecieptByDateRange/`, data);
  }

  deleteReciept(id) {
    return http.delete(`/deleteReciept/${id}`);
  }
  //reciept***
  getAll() {
    return http.get("/tutorials");
  }

  get(id) {
    return http.get(`/tutorials/${id}`);
  }

  create(data) {
    return http.post("/tutorials", data);
  }

  update(id, data) {
    return http.put(`/tutorials/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tutorials/${id}`);
  }
  deleteCauses(id) {
    return http.delete(`/causes/${id}`);
  }
  deleteCategory(id) {
    return http.delete(`/category/${id}`);
  }

  deleteAll() {
    return http.delete(`/tutorials`);
  }

  findByTitle(title) {
    return http.get(`/tutorials?title=${title}`);
  }

  findByClassID(classID) {
    return http.post(`/findByClassID/id=`, classID);
  }
  ////////////////////

  createClass(data) {
    return http.post("/createClass", data);
  }

  updateLevelEduClass(id, data) {
    return http.put(`/updateLevelEduClass/${id}`, data);
  }
  getAllCLass() {
    return http.get("/getAllClass");
  }

  getAllCauses() {
    return http.get("/getAllCauses");
  }

  getCategory() {
    return http.get("/getCategory");
  }

  //BUS
  getBusInfo(key = "") {
    const path = key ? `/busInfo/${key}` : `/busInfo`;
    return http.get(path);
  }

  updateBusInfo(data) {
    return http.post(`/busInfo`, data);
  }

  //achive
  // ===== ACHIEVEMENTS =====
  createAchievements(data) {
    return http.post("/createAchievements", data);
  }
  getAllAchievements() {
    return http.get("/getAllAchievements");
  }
  getAchievementsByStudentId(id) {
    return http.get(`/getAchievementsByStudentId/${id}`);
  }
  updateAchievements(id, data) {
    return http.put(`/updateAchievements/${id}`, data);
  }
  deleteAchievements(id) {
    return http.delete(`/deleteAchievements/${id}`);
  }

  // ===== HONOR BOARD =====
  sendStudentToHonorBoard(id, data = {}) {
    return http.put(`/sendStudentToHonorBoard/${id}`, data);
  }
  deleteStudentFromHonorBoard(id, data = {}) {
    return http.put(`/deleteStudentFromHonorBoard/${id}`, data);
  }
  getStudentsWithHonorBoard() {
    return http.get("/getStudentsWithHonorBoard");
  }

  // ===== RATING =====
  getRating(period = "all", classID = "") {
    const params = new URLSearchParams({ period });
    if (classID) params.append("classID", classID);
    return http.get(`/getRating?${params.toString()}`);
  }
  getRatingByClass(period = "all") {
    return http.get(`/getRatingByClass?period=${period}`);
  }
  /////////////////// students
  createStudent(data) {
    return http.post("/createStudent", data);
  }

  EditStudentServerFLS(data) {
    return http.post("/EditStudentServerFLS", data);
  }

  deleteStudent(id) {
    return http.delete(`/student/${id}`);
  }
  changeClassStudent(data) {
    return http.post("/changeClassStudent", data);
  }
  changeMaxIDStudent(data) {
    return http.post("/changeMaxIDStudent", data);
  }
  deleteMaxIDStudent(data) {
    return http.post("/deleteMaxIDStudent", data);
  }

  changeMaxIDparentStudent(data) {
    return http.post("/changeMaxIDparentStudent", data);
  }

  deleteMaxIDparentStudent(data) {
    return http.post("/deleteMaxIDparentStudent", data);
  }

  findStudentByClassID(classID) {
    return http.post(`/findStudentByClassID/id=`, classID);
  }

  findStudentByClassIDbyDashboard(classID) {
    return http.post(`/findStudentByClassIDbyDashboard/id=`, classID);
  }
  findStudentByID(id) {
    return http.post(`/findStudentByID/id=`, id);
  }
  findStudentByID_securityCheck(id) {
    return http.post(`/findStudentByIDsecurityCheck/id=`, id);
  }

  //Category
  createCategory(data) {
    return http.post("/createCategory", data);
  }
  updateCat(id, data) {
    return http.put(`/updateCat/${id}`, data);
  }

  updateCatOrderStudent(id, data) {
    return http.put(`/updateCatOrderStudent/${id}`, data);
  }

  createCauses(data) {
    return http.post("/createCauses", data);
  }
  createDate(data) {
    return http.post("/createDate", data);
  }

  ///marks
  createMarks(data) {
    return http.post("/createMarks", data);
  }
  createMarksEating(data) {
    return http.post("/createMarksEating", data);
  }
  findMarks(classID) {
    return http.post(`/findMarks/id=`, classID);
  }
  updateMark(id, data) {
    return http.put(`/updateMark/${id}`, data);
  }
  updateMarkAdmin(id, data) {
    return http.put(`/updateMarkAdmin/${id}`, data);
  }
  findMarksByDateRange(classID) {
    return http.post(`/findMarksByDateRange/`, classID);
  }

  ///*** FILE
  sendFile(data) {
    return httpFile.post(`/single-file`, data);
  }

  getFile(data) {
    return http.post(`/loadFileID`, data, {
      responseType: "blob",
      observe: "response",
    });
  }

  loadImportStudentsTemplates() {
    return http.get(`/loadImportStudentsTemplates`, {
      responseType: "blob",
      observe: "response",
    });
  }
  loadImportClassTemplates() {
    return http.get(`/loadImportClassTemplates`, {
      responseType: "blob",
      observe: "response",
    });
  }

  sendPhoto(data) {
    return httpFile.post(`/sendPhoto`, data);
  }

  /// CLUBS

  crateClub(data) {
    return http.post("/createCLub", data);
  }

  getClubs() {
    return http.get("/getClubs");
  }

  addClubsStudent(data) {
    return http.post("/addClubsStudent", data);
  }
  recalculateClubStat() {
    return http.post("/recalculateClubStat");
  }

  recalculateClubStudent() {
    return http.post("/recalculateClubStudent");
  }

  deleteDublecateMarks(data) {
    return http.post("/deleteDublecateMarks", data);
  }

  //postAD

  createAD(data) {
    return http.post("/createAD", data);
  }
  getAD() {
    return http.get("/getAD");
  }

  deleteAD(id) {
    return http.delete(`/AD/${id}`);
  }

  createDayWeekMenu(data) {
    return http.post("/createDayWeekMenu", data);
  }
  deleteDayWeekMenu(data) {
    return http.post("/deleteDayWeekMenu", data);
  }
  updateDayWeekMenu(id, data) {
    return http.put(`/updateDayWeekMenu/${id}`, data);
  }

  findDayWeekMenuByDateRange(data) {
    return http.post("/findDayWeekMenuByDateRange", data);
  }
  addclassDayWeekMenu(data) {
    return http.post("/addclassDayWeekMenu", data);
  }

  getTelegramToken(data) {
    return http.get("/getTelegramToken", data);
  }
  createTelegramToken(data) {
    return http.post("/createTelegramToken", data);
  }
  updateTelegramToken(data) {
    return http.post("/updateTelegramToken", data);
  }

  //inventary

  createINV(data) {
    return http.post("/createINV", data);
  }
  getAllINV(data) {
    return http.get("/getAllINV", data);
  }
  updateINV(id, data) {
    return http.put(`/updateINV/${id}`, data);
  }
  findINVByID(id) {
    return http.post("/findINVByID/:id", id);
  }
  deleteINV(id) {
    return http.delete(`/deleteINV/${id}`);
  }

  //calendarEvents
  createEvent(data) {
    return http.post("/createEvent", data);
  }
  getAllEvent(data) {
    return http.get("/getAllEvent", data);
  }
  editEvent(id, data) {
    return http.put(`/editEvent/${id}`, data);
  }
  deleteEvent(id) {
    return http.delete(`/deleteEvent/${id}`);
  }

  //violations
  createViolations(data) {
    return http.post("/createViolations", data);
  }
  getAllViolations() {
    return http.get("/getAllViolations");
  }
  getViolationsByStudentId(id) {
    return http.get(`/getViolationsByStudentId/${id}`);
  }
  deleteViolations(id) {
    return http.delete(`/deleteViolations/${id}`);
  }
  updateViolations(id, data) {
    return http.put(`/updateViolations/${id}`, data);
  }
  sendStudentToAIC(id, data) {
    return http.put(`/sendStudentToAIC/${id}`, data);
  }
  deleteStudentToAIC(id, data) {
    return http.put(`/deleteStudentToAIC/${id}`, data);
  }
  getStudentsWithAIC() {
    return http.get("/getStudentsWithAIC");
  }

  //users
  createUser(data) {
    return http.post(`/paid_createUser`, data);
  }
  getUsers() {
    return http.get(`/paid_getUsers`);
  }
  changeMaxIDUser(data) {
    return http.post("/changeMaxIDUser", data);
  }
  deleteMaxIDUser(data) {
    return http.post("/deleteMaxIDUser", data);
  }

  deleteUser(id) {
    return http.post(`/paid_deleteUser`, id);
  }
  updateUser(data) {
    return http.post(`/paid_updateUser`, data);
  }

  //AIC
  createAIC(data) {
    return http.post("/createAIC", data);
  }

  getAllAIC() {
    return http.get("/getAllAIC");
  }

  getAICByStudent(studentID) {
    return http.get(`/getAICByStudent/${studentID}`);
  }

  getAICByDateRange(startDate, endDate) {
    return http.get(
      `/getAICByDateRange?startDate=${startDate}&endDate=${endDate}`,
    );
  }

  getAICById(id) {
    return http.get(`/getAICById/${id}`);
  }

  updateStudentEmotionalState(studentID, data) {
    return http.post(`/updateStudentEmotionalState`, {
      studentID: studentID,
      emotionalState: data.emotionalState,
    });
  }

  updateStudentRiskZones(studentID, data) {
    return http.post(`/updateStudentRiskZones`, {
      studentID: studentID,
      riskZones: data.riskZones,
    });
  }
  updateStudentPhoto(studentID, data) {
    return http.post(`/updateStudentPhoto`, {
      studentID: studentID,
      photo: data.photo,
    });
  }
}

export function updateAxiosInstance() {
  http.defaults.baseURL = window.myVariable;
}

export default new TutorialDataService();
